import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class roleSelectionCtrl implements IController {

  rolesMap: any;
  selectedRoles: any;
  isShowChips: boolean;
  onChange: Function;

  public queryString: string;
  public filteredRolesMap: any;
  public selectedKeys: Object = {};

  private sections: any;
  private excludeIds: any;
  private selectedChips: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

    this.sections = {};

    if (!this.selectedRoles) {
      this.selectedRoles = [];
    }
    this.excludeIds = _.map(this.selectedRoles, (r) => {
      return r.id;
    });

    this.selectedChips = this._rolesToChip(this.selectedRoles);

    _.forOwn(this.rolesMap, (roles, key) => {
      this.sections[key] = false;
    });

    this.filteredRolesMap = this.rolesMap;
  };

  $onChanges(changes) {
    if (changes.selectedRoles) {

      this.selectedKeys = {};
      _.forEach(this.selectedRoles, (r) => {
        this.selectedKeys[r.id] = true;
      });


      this.excludeIds = _.map(this.selectedRoles, (r) => {
        return r.id;
      });

      this.selectedChips = this._rolesToChip(this.selectedRoles);
    }
  };

  ////////////////////////////////////////////////////////////////////////


  _filterRolesMap(query) {
    this.filteredRolesMap = {}
    _.forOwn(this.rolesMap, (permissions, groupName) => {
      const permissionsArray = _.filter(permissions, (role) => {
        return _.includes(role.translation.toLowerCase(), query.toLowerCase())
      })
      if (permissionsArray.length) {
        this.filteredRolesMap[groupName] = permissionsArray
        this.sections[groupName] = true;
      } else {
        this.sections[groupName] = false;
      }
    })

  }
  toggleGroup(groupName) {
    _.forOwn(this.sections, (value, key) => {
      this.sections[key] = key === groupName ? !this.sections[key] : false;
    });
  }


  submitQuery(query) {
    this.queryString = query;
    this._filterRolesMap(query)
  }


  onClear() {
    this.selectedChips = [];
    this.onChange({roles: []})
  }

  onToggle(role) {
    const isCurrentlySelected = this.selectedRoles?.find((r) => {
      return r.id === role.id;
    })

    if (isCurrentlySelected) {
      this.onRemove(role);
    } else {
      this.onAdd(role);
    }
  }

  onAdd(role) {
    this.selectedChips.push({name: 'roles.' + role.id, id: role.id});

    const updatedRoles = this.selectedRoles.concat([role]);
    this.onChange({roles: updatedRoles});
  }

  onRemove(role) {
    const updatedRoles = _.filter(this.selectedRoles, (r) => {
      return r.id !== role.id;
    });

    this.onChange({roles: updatedRoles})
  }


  _rolesToChip(roles) {
    return _.map(roles, (r) => {
      return {name: 'roles.' + r.id, id: r.id};
    });
  }

}

angular
  .module('bringoz.admin.policies')
  .component('roleSelection', {
    bindings: {
      rolesMap: '<',
      selectedRoles: '<',
      isShowChips: '<?',
      onChange: '&'
    },
    template: require('./role-selection.html').default,
    controller: roleSelectionCtrl
  });
